import { render, staticRenderFns } from "./my-ruler-ver.vue?vue&type=template&id=44348dfc&scoped=true&"
import script from "./my-ruler-ver.vue?vue&type=script&lang=js&"
export * from "./my-ruler-ver.vue?vue&type=script&lang=js&"
import style0 from "./my-ruler-ver.vue?vue&type=style&index=0&id=44348dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44348dfc",
  null
  
)

export default component.exports